import React from 'react';
import { Image, View } from 'react-native';

const ProductImage = ({
	uri,
	style,
	resizeMode = 'contain',
	placeholderStyle,
}) => {
	if (uri) {
		return (
			<Image
				source={{ uri }}
				style={style}
				resizeMode={resizeMode}
			/>
		);
	}

	return (
		<View
			style={[
				style,
				{
					backgroundColor: '#f0f0f0',
					borderRadius: style?.borderRadius || 0,
				},
				placeholderStyle,
			]}
		/>
	);
};

export default ProductImage;
